<div class="hero-container sign-in-view d-flex vw-100 vh-100">
  <div class="content d-flex flex-column justify-content-between vh-100">
    <div class="logo d-flex flex-row align-items-center">
      <img src="assets/hero/images/logo-hero.svg" alt="Hero" class="hero-logo" />
      <div class="vr"></div>
      <img src="assets/client/images/logo-client.svg" alt="Client" class="client-logo" />
    </div>
    <div class="">
      <h1 class="headline" dictionary="welcome">Willkommen.</h1>
      <host-sign-in></host-sign-in>
    </div>
    <div class="powered-by">Powered by © Hero AI</div>
  </div>
  <div class="emotional"></div>
</div>
